export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-competencies-item-legal.vue?vue&type=template&id=1f0a703c&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-competencies-item/lk-competencies-item-legal.vue?vue&type=template&id=1f0a703c&
// module id = 1419
// module chunks = 0